// In-memory stand-in for a future comments API (e.g. GET/POST /journeys/:key/comments).
// Call sites only deal with plain data in and plain data out, so swapping the body of
// each function for a real HTTP call later shouldn't require touching any caller.
//
// Backed by a Vue instance (rather than a plain object) so computed properties in any
// component that reads listComments()/listAllComments() stay reactive across the whole
// module without manual refresh plumbing between the stage tab and the all-comments modal.

import Vue from 'vue'
import { getCurrentUserName } from './currentUser'

const state = new Vue({
  data: { byJourneyKey: {} }
})

let nextId = 1

function bucket (journeyKey) {
  if (!state.byJourneyKey[journeyKey]) Vue.set(state.byJourneyKey, journeyKey, [])
  return state.byJourneyKey[journeyKey]
}

export function listComments (journeyKey, stageName) {
  return bucket(journeyKey).filter(c => c.stageName === stageName)
}

export function listAllComments (journeyKey) {
  return bucket(journeyKey)
}

export function addComment (journeyKey, stageName, text) {
  const trimmed = (text || '').trim()
  if (!trimmed) return null
  const comment = {
    id: nextId++,
    stageName,
    author: getCurrentUserName(),
    text: trimmed,
    createdAt: Date.now(),
    resolved: false
  }
  bucket(journeyKey).push(comment)
  return comment
}

export function setCommentResolved (journeyKey, commentId, resolved) {
  const comment = bucket(journeyKey).find(c => c.id === commentId)
  if (comment) comment.resolved = resolved
  return comment
}

// A journey's dropdown key can change out from under its comments (e.g. an AI edit
// renames it, or the untitled draft gets its first real name) — carry them over to the
// new key instead of losing them, same as journeyVersions.renameJourney.
export function renameJourney (oldKey, newKey) {
  if (oldKey === newKey || !state.byJourneyKey[oldKey] || state.byJourneyKey[newKey]) return
  Vue.set(state.byJourneyKey, newKey, state.byJourneyKey[oldKey])
  Vue.delete(state.byJourneyKey, oldKey)
}



// WEBPACK FOOTER //
// ./src/components/user-journey/journey-flow/journeyComments.js